import { FilterTypes } from 'Core/interfaces'

import { UrlParams, UrlParamsLabel } from 'Portals/Customer/constants'
import { Audit, AuditFilterFields, AuditMainSearchFields } from 'Portals/Customer/entities'
import { createdUserToLabelValue } from 'Portals/Customer/utils'
import i18n from 'Portals/Customer/utils/i18nService'

export const getMainSearchConfig = (): Audit.Search.Config => ({
	[AuditMainSearchFields.serviceSiteId]: {
		label: i18n.t('pages:audit.filters.serviceSiteId'),
		apiFieldName: AuditMainSearchFields.serviceSiteId,
		apiSearchFieldName: 'serviceSiteId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceSiteId,
		UrlParamLabel: UrlParamsLabel.companyLocation,
		isLabelAndId: true
	},
	[AuditMainSearchFields.locationName]: {
		label: i18n.t('pages:audit.filters.name'),
		apiFieldName: AuditMainSearchFields.locationName,
		apiSearchFieldName: 'serviceSiteId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.locationName,
		UrlParamLabel: UrlParamsLabel.companyLocation
	},
	[AuditMainSearchFields.createdUser]: {
		label: i18n.t('pages:audit.filters.createdBy'),
		apiFieldName: AuditMainSearchFields.createdUser,
		apiSearchFieldName: 'CreatedByUserId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.createdUserId,
		UrlParamLabel: UrlParamsLabel.userCreator,
		customOptionFormatter: createdUserToLabelValue
	},
	[AuditMainSearchFields.updatedUser]: {
		label: i18n.t('pages:audit.filters.updatedBy'),
		apiFieldName: AuditMainSearchFields.updatedUser,
		apiSearchFieldName: 'UpdatedByUserId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.updatedUserId,
		UrlParamLabel: UrlParamsLabel.userUpdater,
		customOptionFormatter: createdUserToLabelValue
	}
})

export const getFilterConfig = (): Audit.Filter.Config => ({
	[AuditFilterFields.createFrom]: {
		label: `${i18n.t('pages:audit.filters.createDateFrom')}:`,
		apiFilterFieldName: AuditFilterFields.createFrom,
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.createDateFrom,
		defaultValue: null
	},
	[AuditFilterFields.createTo]: {
		label: `${i18n.t('pages:audit.filters.createDateTo')}:`,
		apiFilterFieldName: AuditFilterFields.createTo,
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.createDateTo,
		defaultValue: null
	},
	[AuditFilterFields.updateFrom]: {
		label: `${i18n.t('pages:audit.filters.updateDateFrom')}:`,
		apiFilterFieldName: AuditFilterFields.updateFrom,
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.updateDateFrom,
		defaultValue: null
	},
	[AuditFilterFields.updateTo]: {
		label: `${i18n.t('pages:audit.filters.updateDateTo')}:`,
		apiFilterFieldName: AuditFilterFields.updateTo,
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.updateDateTo,
		defaultValue: null
	},
	[AuditFilterFields.isUpdatedOnly]: {
		label: i18n.t('pages:audit.filters.updatedOnly'),
		apiFilterFieldName: AuditFilterFields.isUpdatedOnly,
		filterType: FilterTypes.BOOLEAN,
		UrlParam: UrlParams.isUpdatedOnly,
		defaultValue: false
	},
	[AuditFilterFields.isExceedThreshold]: {
		label: i18n.t('pages:audit.filters.isExceed'),
		apiFilterFieldName: AuditFilterFields.isExceedThreshold,
		filterType: FilterTypes.BOOLEAN,
		UrlParam: UrlParams.isExceedThreshold,
		defaultValue: false
	},
	[AuditFilterFields.KpiCategoryCode]: {
		label: `${i18n.t('pages:audit.filters.kpiCategory')}:`,
		apiFilterFieldName: AuditFilterFields.KpiCategoryCode,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.kpiCategoryId,
		defaultValue: null
	},
	[AuditFilterFields.kpiId]: {
		label: `${i18n.t('pages:audit.filters.kpi')}:`,
		apiFilterFieldName: AuditFilterFields.kpiId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.kpiId,
		defaultValue: null
	}
})
